import { FractionType } from '@/features/report-snapshots/interfaces';

function processDenominator(denominator: number, unit: string) {
  switch (unit) {
    case 'seconds':
      return denominator / 3600;
    default:
      return denominator;
  }
}

export function calculateFractionValue(fraction: FractionType) {
  const result =
    fraction.numerator.value /
    processDenominator(fraction.denominator.value, fraction.denominator.unit);

  return result;
}

export const formatRatio = (fraction: FractionType): string => {
  const ratio = calculateFractionValue(fraction);

  return Number.isFinite(ratio) ? ratio.toFixed(1) : '\u2014';
};
